import { Category } from '../types'

export const categories: Category[] = [
  {
    id: 'adaptive-clothing',
    name: 'Adaptive Clothing',
    slug: 'adaptive-clothing',
    color: 'bg-[#D4C5B0]',
    image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=500',
    description: 'Clothing designed for ease of dressing and comfort',
    subcategories: [
      {
        id: 'tops',
        name: 'Tops & Shirts',
        slug: 'tops',
        color: 'bg-[#E5D9C8]',
        image:
          'https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=400',
        parentSlug: 'adaptive-clothing',
      },
      {
        id: 'bottoms',
        name: 'Bottoms & Pants',
        slug: 'bottoms',
        color: 'bg-[#D4C5B0]',
        image:
          'https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?w=400',
        parentSlug: 'adaptive-clothing',
      },
      {
        id: 'footwear',
        name: 'Footwear',
        slug: 'footwear',
        color: 'bg-[#C5B5A0]',
        image:
          'https://images.unsplash.com/photo-1460353581641-37baddab0fa2?w=400',
        parentSlug: 'adaptive-clothing',
        subcategories: [
          {
            id: 'sneakers',
            name: 'Sneakers',
            slug: 'sneakers',
            color: 'bg-gray-100',
            parentSlug: 'footwear',
          },
          {
            id: 'sandals',
            name: 'Sandals',
            slug: 'sandals',
            color: 'bg-gray-100',
            parentSlug: 'footwear',
          },
          {
            id: 'slippers',
            name: 'Slippers',
            slug: 'slippers',
            color: 'bg-gray-100',
            parentSlug: 'footwear',
          },
        ],
      },
      {
        id: 'accessories',
        name: 'Accessories',
        slug: 'accessories',
        color: 'bg-[#B5A590]',
        image:
          'https://images.unsplash.com/photo-1611652022419-a9419f74343d?w=400',
        parentSlug: 'adaptive-clothing',
      },
    ],
  },
  {
    id: 'hearing-health',
    name: 'Hearing & Health',
    slug: 'hearing-health',
    color: 'bg-[#B0C4D4]',
    image: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=500',
    description: 'Hearing aids and health monitoring devices',
    subcategories: [
      {
        id: 'hearing-aids',
        name: 'Hearing Aids',
        slug: 'hearing-aids',
        color: 'bg-[#C0D4E4]',
        image:
          'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=400',
        parentSlug: 'hearing-health',
        subcategories: [
          {
            id: 'rechargeable',
            name: 'Rechargeable',
            slug: 'rechargeable',
            color: 'bg-blue-50',
            parentSlug: 'hearing-aids',
          },
          {
            id: 'bluetooth',
            name: 'Bluetooth-Enabled',
            slug: 'bluetooth',
            color: 'bg-blue-50',
            parentSlug: 'hearing-aids',
          },
          {
            id: 'invisible',
            name: 'Invisible/Discreet',
            slug: 'invisible',
            color: 'bg-blue-50',
            parentSlug: 'hearing-aids',
          },
        ],
      },
      {
        id: 'amplifiers',
        name: 'Sound Amplifiers',
        slug: 'amplifiers',
        color: 'bg-[#B0C4D4]',
        image:
          'https://images.unsplash.com/photo-1545259742-24f9c7ff7e3d?w=400',
        parentSlug: 'hearing-health',
      },
      {
        id: 'accessories-hearing',
        name: 'Accessories & Batteries',
        slug: 'accessories-hearing',
        color: 'bg-[#A0B4C4]',
        image:
          'https://images.unsplash.com/photo-1609091839311-d5365f9ff1c5?w=400',
        parentSlug: 'hearing-health',
      },
    ],
  },
  {
    id: 'mobility',
    name: 'Mobility Aids',
    slug: 'mobility',
    color: 'bg-[#B0D4B8]',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=500',
    description: 'Walkers, canes, and mobility assistance',
    subcategories: [
      {
        id: 'walkers',
        name: 'Walkers & Rollators',
        slug: 'walkers',
        color: 'bg-[#C0E4C8]',
        image:
          'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400',
        parentSlug: 'mobility',
      },
      {
        id: 'canes',
        name: 'Canes & Walking Sticks',
        slug: 'canes',
        color: 'bg-[#B0D4B8]',
        image:
          'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400',
        parentSlug: 'mobility',
      },
      {
        id: 'wheelchairs',
        name: 'Wheelchairs & Scooters',
        slug: 'wheelchairs',
        color: 'bg-[#A0C4A8]',
        image:
          'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?w=400',
        parentSlug: 'mobility',
      },
    ],
  },
  {
    id: 'home-safety',
    name: 'Home Safety',
    slug: 'home-safety',
    color: 'bg-[#D4B0B0]',
    image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=500',
    description: 'Safety equipment and home modifications',
    subcategories: [
      {
        id: 'bathroom',
        name: 'Bathroom Safety',
        slug: 'bathroom',
        color: 'bg-[#E4C0C0]',
        image:
          'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=400',
        parentSlug: 'home-safety',
      },
      {
        id: 'alert-systems',
        name: 'Medical Alert Systems',
        slug: 'alert-systems',
        color: 'bg-[#D4B0B0]',
        image:
          'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=400',
        parentSlug: 'home-safety',
      },
      {
        id: 'lighting',
        name: 'Lighting & Visibility',
        slug: 'lighting',
        color: 'bg-[#C4A0A0]',
        image:
          'https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?w=400',
        parentSlug: 'home-safety',
      },
    ],
  },
  {
    id: 'personal-care',
    name: 'Personal Care',
    slug: 'personal-care',
    color: 'bg-[#C4B0D4]',
    image: 'https://images.unsplash.com/photo-1576426863848-c2185fc6e3c1?w=500',
    description: 'Daily living aids and personal care products',
    subcategories: [
      {
        id: 'grooming',
        name: 'Grooming Aids',
        slug: 'grooming',
        color: 'bg-[#D4C0E4]',
        parentSlug: 'personal-care',
      },
      {
        id: 'dressing',
        name: 'Dressing Aids',
        slug: 'dressing',
        color: 'bg-[#C4B0D4]',
        parentSlug: 'personal-care',
      },
    ],
  },
  {
    id: 'medical-devices',
    name: 'Medical Devices',
    slug: 'medical-devices',
    color: 'bg-[#B0D4D1]',
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=500',
    description: 'Health monitoring and medical equipment',
    subcategories: [
      {
        id: 'monitors',
        name: 'Blood Pressure Monitors',
        slug: 'monitors',
        color: 'bg-[#C0E4E1]',
        parentSlug: 'medical-devices',
      },
      {
        id: 'glucose',
        name: 'Glucose Meters',
        slug: 'glucose',
        color: 'bg-[#B0D4D1]',
        parentSlug: 'medical-devices',
      },
    ],
  },
  {
    id: 'nutrition',
    name: 'Nutrition',
    slug: 'nutrition',
    color: 'bg-[#D4CBB0]',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=500',
    description: 'Meal delivery and nutritional supplements',
    subcategories: [
      {
        id: 'meal-delivery',
        name: 'Meal Delivery Services',
        slug: 'meal-delivery',
        color: 'bg-[#E4DBC0]',
        parentSlug: 'nutrition',
      },
      {
        id: 'supplements',
        name: 'Supplements & Vitamins',
        slug: 'supplements',
        color: 'bg-[#D4CBB0]',
        parentSlug: 'nutrition',
      },
    ],
  },
  {
    id: 'wellness',
    name: 'Wellness',
    slug: 'wellness',
    color: 'bg-[#D4B0C4]',
    image: 'https://images.unsplash.com/photo-1544367563-12123d8965cd?w=500',
    description: 'Fitness, therapy, and wellness products',
    subcategories: [
      {
        id: 'exercise',
        name: 'Exercise Equipment',
        slug: 'exercise',
        color: 'bg-[#E4C0D4]',
        parentSlug: 'wellness',
      },
      {
        id: 'therapy',
        name: 'Therapy & Recovery',
        slug: 'therapy',
        color: 'bg-[#D4B0C4]',
        parentSlug: 'wellness',
      },
    ],
  },
]

// Helper function to find category by slug path
export function findCategoryByPath(slugs: string[]): Category | null {
  let current: Category[] = categories
  let found: Category | null = null

  for (const slug of slugs) {
    found = current.find((cat) => cat.slug === slug) || null
    if (!found) return null
    if (found.subcategories) {
      current = found.subcategories
    }
  }

  return found
}

// Helper to build breadcrumb from slug path
export function buildBreadcrumb(
  slugs: string[],
): { name: string; slug: string; path: string }[] {
  const breadcrumb: { name: string; slug: string; path: string }[] = [
    { name: 'All Categories', slug: 'explore', path: '/explore' },
  ]

  let current: Category[] = categories
  let pathSoFar: string[] = []

  for (const slug of slugs) {
    const found = current.find((cat) => cat.slug === slug)
    if (!found) break

    pathSoFar.push(slug)
    breadcrumb.push({
      name: found.name,
      slug: found.slug,
      path: `/category/${pathSoFar.join('/')}`,
    })

    if (found.subcategories) {
      current = found.subcategories
    }
  }

  return breadcrumb
}
